import { CircleDot, ListChecks, Star, Target } from 'lucide-react'

import type { MyDataMission } from '../types'

import { Card, CardBody, CardHeader, CardTitle } from '@/shared/ui/Card'

import { EntityRows, RichEmpty } from './EntityListCard'

function SubHeader({
  icon: Icon,
  label
}: {
  icon: typeof ListChecks
  label: string
}) {
  return (
    <div className="mb-2 flex items-center gap-1.5 text-xs font-bold uppercase tracking-wide text-muted-foreground">
      <Icon className="size-3.5" aria-hidden />
      {label}
    </div>
  )
}

interface MissionsCardProps {
  concluidas: MyDataMission[]
  emAndamento: MyDataMission[]
}

export function MissionsCard({ concluidas, emAndamento }: MissionsCardProps) {
  const noMissions = concluidas.length === 0 && emAndamento.length === 0

  return (
    <Card variant="default">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <span className="text-primary">
            <Target className="size-5" aria-hidden />
          </span>
          Missões
        </CardTitle>
      </CardHeader>
      <CardBody className="flex flex-col gap-4">
        {noMissions ? (
          <RichEmpty
            icon={Target}
            message="Você ainda não tem missões. Que tal começar agora?"
            cta={{ label: 'Ver missões', href: '/missoes' }}
          />
        ) : (
          <>
            <div>
              <SubHeader icon={ListChecks} label={`Concluídas (${concluidas.length})`} />
              {concluidas.length ? (
                <EntityRows items={concluidas} icon={Star} />
              ) : (
                <p className="text-sm font-semibold italic text-muted-foreground">
                  Nenhuma missão concluída ainda.
                </p>
              )}
            </div>
            <div>
              <SubHeader icon={CircleDot} label={`Em andamento (${emAndamento.length})`} />
              {emAndamento.length ? (
                <EntityRows
                  items={emAndamento.map(mission => ({
                    id: mission.id,
                    nome: mission.nome,
                    extra:
                      mission.progresso_atual != null ? `${mission.progresso_atual}` : null
                  }))}
                  icon={CircleDot}
                />
              ) : (
                <p className="text-sm font-semibold italic text-muted-foreground">
                  Nenhuma missão em andamento.
                </p>
              )}
            </div>
          </>
        )}
      </CardBody>
    </Card>
  )
}
